import React, { useContext } from "react";

import { CARD_LIST } from "../../constants";
import {
  OmahaContext,
  OmahaActionTypes,
  OMAHA_HOLE_CARDS,
  cardsInPlay,
  boardCards
} from "../../context/omahaStore";

// Display order: spades, hearts, clubs, diamonds.
export const SUIT_ORDER = ["s", "h", "c", "d"];
export const SUIT_GLYPHS = { s: "♠", h: "♥", d: "♦", c: "♣" };

export function isRedSuit(suit) {
  return suit === "h" || suit === "d";
}

export function Card(props) {
  const { rank, suit } = props;
  return (
    <>
      <span className="deckCardRank">{rank}</span>
      <span className={isRedSuit(suit) ? "deckCardSuit suitRed" : "deckCardSuit"}>
        {SUIT_GLYPHS[suit]}
      </span>
    </>
  );
}

// The deck is the only honest control for four hole cards: 4 clicks, and an
// invalid hand cannot be expressed because used cards are disabled.
export default function DeckPicker(props) {
  const [state, dispatch] = useContext(OmahaContext);
  const hand = state.hands[state.selected] || [];
  const inPlay = cardsInPlay(state);
  const onBoard = new Set(boardCards(state.board));
  const full = hand.length >= OMAHA_HOLE_CARDS;

  function toggle(card) {
    if (hand.includes(card)) {
      dispatch({ type: OmahaActionTypes.UNPICK_CARD, card });
      return;
    }
    dispatch({ type: OmahaActionTypes.PICK_CARD, card });
  }

  return (
    <div className="deckGrid">
      {SUIT_ORDER.map(suit =>
        CARD_LIST.map(rank => {
          const card = rank + suit;
          const mine = hand.includes(card);
          // Dead = genuinely unavailable (on the board or in another hand).
          // Locked = available, but this seat has no room — a different thing,
          // so it gets a different weight rather than reading as "used".
          const dead = !mine && inPlay.has(card);
          const locked = !mine && !dead && full;
          const heldBy = onBoard.has(card) ? "on the board" : "already used";
          return (
            <button
              type="button"
              key={card}
              className={
                "deckCard" +
                (mine ? " deckCard--mine" : "") +
                (dead ? " deckCard--dead" : "") +
                (locked ? " deckCard--locked" : "")
              }
              disabled={dead || locked}
              aria-pressed={mine}
              title={
                mine
                  ? card + " — click to remove"
                  : dead
                  ? card + " — " + heldBy
                  : locked
                  ? card + " — hand is full, remove a card first"
                  : card
              }
              onClick={() => toggle(card)}
            >
              <Card rank={rank} suit={suit} />
            </button>
          );
        })
      )}
    </div>
  );
}
